import { EntityRequestOvertime } from "../../entity/EntityRequestOvertime";

export class DtoRequestOvertimesPutRes extends EntityRequestOvertime {}
